import angular from 'angular';

const userOrderServices = angular.module('applicationModule.logsServices', []);

userOrderServices.factory('Logs', ['LogsAPI', function (LogsAPI) {
    'use strict';

    return {
        getList: function (appId, params) {
            return LogsAPI.getLogs(appId, params)
                .then(function (response) {
                    return response.data.order_logs;
                });
        },
        downloadReport: function (appId, endDate, startDate, details) {
            return LogsAPI.downloadReport(appId, endDate, startDate, details);
        }
    };
}]);

userOrderServices.service('LogsAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const LOGS_URL = AppsoupAPI.API_URL + '/app/logs/';

    this.getLogs = function (appId, params) {
        return $http.get(LOGS_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.downloadReport = function (appId, endDate, startDate, details) {
        return $http.get(LOGS_URL + 'report/', {
            params: {
                application_id: appId,
                end_date: endDate,
                start_date: startDate,
                details: details
            }
        });
    };
}]);

export default userOrderServices;
